const translations = {
    backButtonText: 'Back',
    confirmationText: 'Are you sure you want to discard this form?',
    discardButtonText: 'Discard'
};

export default translations;
